import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { DonationService } from '../../services/donation.service';
import { AnnualReceiptsApiActions, AnnualReceiptsPageActions } from './annual-receipts.actions';

@Injectable()
export class AnnualReceiptsEffects {
  private readonly actions$ = inject(Actions);
  private readonly donationService = inject(DonationService);

  readonly loadSummary$ = createEffect(() => this.actions$.pipe(
    ofType(AnnualReceiptsPageActions.yearChanged),
    switchMap(({ year }) => this.donationService.getAnnualSummary(year).pipe(
      map((summaries) => AnnualReceiptsApiActions.loadSucceeded({ year, summaries })),
      catchError((error: { message?: string }) => of(AnnualReceiptsApiActions.loadFailed({ year, error: error?.message ?? 'Unable to load annual receipts' }))),
    )),
  ));
}
